import { render } from "./EventDetails.vue?vue&type=template&id=30417eba&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-30417eba"

export default script